import { ReactElement } from "react";
import { Navigate } from "react-router-dom";
import { isPlatformSession } from "../auth/realm";

/** Smistamento post-login: realm platform → console, altrimenti area tenant. */
export function HomeDispatcher(): ReactElement {
  return isPlatformSession()
    ? <Navigate to="/console" replace />
    : <Navigate to="/app/dashboard" replace />;
}
